import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RecentlyViewed = ({ jobs, onViewJob, onApply }) => {
  if (jobs?.length === 0) {
    return null;
  }

  return (
    <div className="mb-6 p-4 md:p-6 bg-card border border-border rounded-lg">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base md:text-lg font-heading font-semibold text-card-foreground">
          Recently Viewed
        </h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {jobs?.map((job) => (
          <div
            key={job?.id}
            className="p-4 bg-muted/50 rounded-lg hover:bg-muted transition-smooth cursor-pointer"
            onClick={() => onViewJob(job)}
          >
            <div className="flex items-start gap-3 mb-3">
              <div className="flex-shrink-0 w-10 h-10 rounded-lg overflow-hidden bg-card">
                <Image
                  src={job?.companyLogo}
                  alt={job?.companyLogoAlt}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-card-foreground line-clamp-1 mb-1">
                  {job?.title}
                </h4>
                <p className="text-xs text-muted-foreground line-clamp-1">
                  {job?.company}
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2 text-xs text-muted-foreground mb-3">
              <Icon name="MapPin" size={14} color="var(--color-muted-foreground)" />
              <span className="line-clamp-1">{job?.location}</span>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={(e) => {
                e?.stopPropagation();
                onApply(job);
              }}
              fullWidth
              iconName="Send"
              iconPosition="left"
            >
              Apply
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentlyViewed;